import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Row,
  Stack,
  Tab,
  Tabs,
} from "react-bootstrap";
import { useEffect, useMemo, useRef, useState } from "react";
import NestedExpandableTable from "../../../common/NestedExpandableTable";
import { INVOICE_STATUS, MANAGE_INVOICE_CODES } from "../../../common/Constant";
import useAnimatedCounter from "../../ToDos/useAnimatedCounter";
import SearchableSingleSelectDropdown from "../../../common/SearchableDropdown";
import AppointmentActionsDropdown from "../../../common/AppointmentActionsDropdown";
import HistorianActionDrawer from "../../ToDos/Historian/components/HistoriansActionDrawer";
import InvoiceAddNotes from "./components/InvoiceAddNotes";
import { CLIENT_INVOICE_HEADER } from "./actions/constants";
import {
  getInvoiceByClientQmeCase,
  getInvoiceByClientQme,
  getInvoiceSummaryByClient,
  getInvoiceByClientRole,
  getInvoiceByClientRoleCase,
  getInvoiceByClientUser,
  getInvoiceByClientUserCase,
  getInvoiceStatusList,
  getInvoiceTeamClientList,
  getInvoiceSummaryCount,
  fetchSyncReProcessing,
} from "../../../services/InvoiceAPI";
import FloatingLabelMonthPicker from "../../../common/MonthPicker";
import { toYearMonth } from "../../../utils/dateUtils";
import SearchableMultiSelectDropdown from "../../../common/SearchableMultiSelectDropdown";
import AccordionComponent from "../../../common/Accordion";
import ViewInvoice from "./components/ViewInvoice";
import GenerateInvoice from "./components/GenerateInvoice";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/Store";
import { DropdownWithTooltip } from "../../../common/DropdownWithTooltip";
import { fetcheaderinfo } from "../../../services/UserRegistrationApi";
import Snackbar from "../../../common/Snackbar";
import InvoiceResolve from "./components/InvoiceResolve";

interface InvoiceStats {
  invoiceAll: string;
  readyToBill: string;
  readyToReBill: string;
  exceptions: string;
  pendingLineItems: string;
  generatedInvoices: string;
}

interface TabConfig {
  key: string;
  title: string;
  summaryApi: (payload: any) => Promise<any>;
  listApi: (payload: any) => Promise<any>;
  detailApi: (payload: any) => Promise<any>;
}

const INVOICE_STATUS_CONFIG = [
  INVOICE_STATUS.EXCEPTION_MULTIPLE_BILLING_CONFIG,
  INVOICE_STATUS.EXCEPTION_MISSING_PAGE_COUNT,
  INVOICE_STATUS.EXCEPTION_MISSING_LINE_COUNT,
  INVOICE_STATUS.ON_HOLD,
  INVOICE_STATUS.CANCELLED,
  INVOICE_STATUS.INVOICED,
  INVOICE_STATUS.GENERATED,
  INVOICE_STATUS.EXCEPTION,
  INVOICE_STATUS.INVOICE_AMENDED,
  INVOICE_STATUS.INVOICE_CANCELLED,
  INVOICE_STATUS.INVOICE_GENERATED,
  INVOICE_STATUS.PENDING,
];

const READY_TO_INVOICE_STATUSES = [
  INVOICE_STATUS.READY_TO_BILL,
  INVOICE_STATUS.READY_TO_RE_BILL,
  INVOICE_STATUS.READY_TO_BILL_AMENDED,
  INVOICE_STATUS.READY_TO_RE_BILL_AMENDED,
];

const EXCEPTION_STATUSES = [
  INVOICE_STATUS.EXCEPTION_NO_BILLING_CONFIG,
  INVOICE_STATUS.EXCEPTION_MULTIPLE_BILLING_CONFIG,
  INVOICE_STATUS.EXCEPTION_MISSING_PAGE_COUNT,
  INVOICE_STATUS.EXCEPTION_MISSING_LINE_COUNT,
  INVOICE_STATUS.ON_HOLD,
  INVOICE_STATUS.EXCEPTION,
  INVOICE_STATUS.EXCEPTION_INVALID_BILLING_CONFIG,
];

const EXCEPTION_PAGE_LINE_STATUSES = [
  INVOICE_STATUS.EXCEPTION_MISSING_PAGE_COUNT,
  INVOICE_STATUS.EXCEPTION_MISSING_LINE_COUNT,
];

const REPROCESS_LINE_ITEM_EXCEP_STATUSES = [
  INVOICE_STATUS.EXCEPTION_NO_BILLING_CONFIG,
  INVOICE_STATUS.EXCEPTION_INVALID_BILLING_CONFIG,
];

const ACTION_VALUES = {
  ADD_NOTES: "Add Notes",
  GENERATE_INVOICE: "Generate Invoice",
  ON_HOLD: "On Hold",
  MISMATCH_INFO: "Mismatch/Incorrect Info",
  REPROCESS: "ReProcessLineItem",
  RESOLVE: "Resolve",
};

const resolveTitleMap: Record<string, string> = {
  [INVOICE_STATUS.EXCEPTION_MISSING_PAGE_COUNT]:
    "Resolve Invoice Line Item Exception - Missing Page Count",
  [INVOICE_STATUS.EXCEPTION_MISSING_LINE_COUNT]:
    "Resolve Invoice Line Item Exception - Missing Line Count",
  [INVOICE_STATUS.EXCEPTION_NO_BILLING_CONFIG]:
    "Resolve Invoice Line Item Exceptions",
  [INVOICE_STATUS.EXCEPTION_MULTIPLE_BILLING_CONFIG]:
    "Resolve Invoice Line Item Exceptions - Multiple Billing Configuration Setup",
};

const Invoice = () => {
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [selectedViewData, setSelectedViewData] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useState<string>("Client");
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [isToDo, setIsToDo] = useState<boolean>(false);
  const [activeFilter, setActiveFilter] = useState(MANAGE_INVOICE_CODES.ALL);
  const [activeCard, setActiveCard] = useState<string>("All Invoices");
  const [activeSubCard, setActiveSubCard] = useState<string>("");
  const [invoiceStats, setInvoiceStats] = useState<InvoiceStats>({
    invoiceAll: "",
    pendingLineItems: "",
    readyToBill: "",
    readyToReBill: "",
    exceptions: "",
    generatedInvoices: "",
  });
  const [drawerTitle, setDrawerTitle] = useState("");
  const [showActionDrawer, setShowActionDrawer] = useState(false);
  const [selectedAction, setSelectedAction] = useState<string | number>("");
  const [statusOptions, setStatusOptions] = useState<any[]>([]);
  const [teamsOptions, setTeamsOptions] = useState<any[]>([]);
  const [month, setMonth] = useState<Date | null>(new Date());
  const [status, setStatus] = useState<(string | number)[]>([]);
  const [teams, setTeams] = useState<string | number | null>(null);
  const [client, setClient] = useState<string | number | null>(null);
  const [tableKey, setTableKey] = useState<string>(`table-${Date.now()}`);
  const [resetTableTrigger, setResetTableTrigger] = useState(false);
  const [clientInvoiceSummaries, setClientInvoiceSummaries] = useState<any[]>(
    [],
  );
  const [roleInvoiceSummaries, setRoleInvoiceSummaries] = useState<any[]>([]);
  const [userInvoiceSummaries, setUserInvoiceSummaries] = useState<any[]>([]);
  const [accordianKey, setAccordianKey] = useState<string | null>("0");
  const [userInfo, setUserInfo] = useState({
    salutationTypeDesc: "",
    firstName: "",
    lastName: "",
    userRoleDescription: "",
  });
  const latestRequestRef = useRef(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const storedData = sessionStorage.getItem("todosViewInvoiceData");
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      setIsToDo(parsedData.isToDo);
      setActiveTab("User");
    }
  }, []);

  const getHeaders = () => {
    const headers = [...CLIENT_INVOICE_HEADER];
    if (activeTab === "Client") {
      headers[1] = { ...headers[1], label: "Task" };
    }

    return headers;
  };

  const tabConfigs: TabConfig[] = [
    {
      key: "Client",
      title: "Client",
      summaryApi: getInvoiceSummaryByClient,
      listApi: getInvoiceByClientQme,
      detailApi: getInvoiceByClientQmeCase,
    },
    {
      key: "Role",
      title: "Role",
      summaryApi: getInvoiceSummaryByClient,
      listApi: getInvoiceByClientRole,
      detailApi: getInvoiceByClientRoleCase,
    },
    {
      key: "User",
      title: "User",
      summaryApi: getInvoiceSummaryByClient,
      listApi: getInvoiceByClientUser,
      detailApi: getInvoiceByClientUserCase,
    },
  ];

  const animatedInvoiceAll = useAnimatedCounter(invoiceStats.invoiceAll);
  const animatedReadyToBill = useAnimatedCounter(invoiceStats.readyToBill);
  const animatedReadyToReBill = useAnimatedCounter(invoiceStats.readyToReBill);
  const animatedExceptions = useAnimatedCounter(invoiceStats.exceptions);
  const animatedGeneratedInvoices = useAnimatedCounter(
    invoiceStats.generatedInvoices,
  );
  const animatedPendingLineItems = useAnimatedCounter(
    invoiceStats.pendingLineItems,
  );

  const isMultiSelect = selectedRows?.length > 1;
  const [showInvoiceTab, setShowInvoiceTab] = useState(false);
  const [showGenerateInvoiceModal, setShowGenerateInvoiceModal] =
    useState(false);

  const allOptions = [
    { value: "Add Notes", label: "Add Notes" },
    { value: "Generate Invoice", label: "Generate Invoice" },
    { value: "On Hold", label: "Line Item - On Hold" },
    { value: "Mismatch/Incorrect Info", label: "Adjustment/Incorrect Data" },
    { value: "Resolve", label: "Resolve" },
    { value: "ReProcessLineItem", label: "Re-Process Line Item" },
  ];

  const allOptionsForToDos = [
    { value: "Add Notes", label: "Add Notes" },
    { value: "ReProcessLineItem", label: "Re-Process Line Item" },
  ];

  const hasStandardCharge = selectedRows?.some(
    (row) => row.taskName === "Standard Charge" || !row.subjectQmeScheduleID,
  );

  const actionOptions = useMemo(() => {
    if (!selectedRows?.length) return [];

    const statuses = selectedRows?.map((row) => row.invoiceLineItemStatus);

    const hasReadyToInvoice = statuses.some((status) =>
      READY_TO_INVOICE_STATUSES.includes(status),
    );

    const hasException = statuses.some((status) =>
      EXCEPTION_STATUSES.includes(status),
    );

    const hasExceptionPageLine = statuses.some((status) =>
      EXCEPTION_PAGE_LINE_STATUSES.includes(status),
    );

    const allReadyToInvoice = statuses.every((status) =>
      READY_TO_INVOICE_STATUSES.includes(status),
    );

    const hasReprocess = statuses.some((status) =>
      REPROCESS_LINE_ITEM_EXCEP_STATUSES.includes(status),
    );

    const hasIncorrectDataException = statuses.some(
      (status) => status === INVOICE_STATUS.EXCEPTION
    );

    const hasOnHoldException = statuses.some(
      (status) => status === INVOICE_STATUS.ON_HOLD
    );

    const filterOptions = (values: string[]) => {
      const filteredValues = hasStandardCharge
        ? values.filter((v) => v !== ACTION_VALUES.REPROCESS)
        : values;

      return allOptions.filter((option) =>
        filteredValues.includes(option.value),
      );
    };

    if (isMultiSelect) {
      return allReadyToInvoice
        ? filterOptions([
            ACTION_VALUES.GENERATE_INVOICE,
            ACTION_VALUES.REPROCESS,
          ])
        : filterOptions([ACTION_VALUES.REPROCESS]);
    }

    if (activeCard === "Exceptions") {
      if (hasIncorrectDataException) {
        return filterOptions([
          ACTION_VALUES.ADD_NOTES,
          ACTION_VALUES.ON_HOLD,
        ]);
      }

      if (hasOnHoldException) {
        return filterOptions([
          ACTION_VALUES.ADD_NOTES,
          ACTION_VALUES.MISMATCH_INFO,
        ]);
      }

      return filterOptions([
        ACTION_VALUES.ADD_NOTES,
        ACTION_VALUES.ON_HOLD,
        ACTION_VALUES.MISMATCH_INFO,
        ...(hasExceptionPageLine ? [ACTION_VALUES.RESOLVE] : []),
        ...(hasReprocess ? [ACTION_VALUES.REPROCESS] : []),
      ]);
    }

    if (hasReadyToInvoice) {
      return hasStandardCharge
        ? filterOptions([
            ACTION_VALUES.GENERATE_INVOICE,
            ACTION_VALUES.ADD_NOTES,
          ])
        : filterOptions([
            ACTION_VALUES.ADD_NOTES,
            ACTION_VALUES.GENERATE_INVOICE,
            ACTION_VALUES.ON_HOLD,
            ACTION_VALUES.MISMATCH_INFO,
            ACTION_VALUES.REPROCESS,
          ]);
    }

    if (hasException && !hasStandardCharge) {
      if (hasIncorrectDataException) {
        return filterOptions([
          ACTION_VALUES.ADD_NOTES,
          ACTION_VALUES.ON_HOLD,
        ]);
      }

      if (hasOnHoldException) {
        return filterOptions([
          ACTION_VALUES.ADD_NOTES,
          ACTION_VALUES.MISMATCH_INFO,
        ]);
      }

      return filterOptions([
        ACTION_VALUES.ADD_NOTES,
        ACTION_VALUES.ON_HOLD,
        ACTION_VALUES.MISMATCH_INFO,
        ...(hasExceptionPageLine ? [ACTION_VALUES.RESOLVE] : []),
        ...(hasReprocess ? [ACTION_VALUES.REPROCESS] : []),
      ]);
    }

    return filterOptions([ACTION_VALUES.ADD_NOTES]);
  }, [selectedRows, isMultiSelect, activeCard, hasStandardCharge, allOptions]);

  const getCurrentTabConfig = () => {
    return tabConfigs.find((tab) => tab.key === activeTab) || tabConfigs[0];
  };

  const fetchInvoiceFilters = () => {
    getInvoiceStatusList()
      .then((res) => setStatusOptions(res || []))
      .catch((err) => console.error("Status API failed:", err));

    getInvoiceTeamClientList()
      .then((res) => setTeamsOptions(res || []))
      .catch((err) => console.error("Team API failed:", err));

    fetcheaderinfo(loggedInUserid)
      .then((userData) => {
        setUserInfo({
          salutationTypeDesc: userData?.salutationtypedesc || "",
          firstName: userData?.firstname || "",
          lastName: userData?.lastname || "",
          userRoleDescription: userData?.userroledescription || "",
        });
      })
      .catch((err) => console.error("User API failed:", err));
  };

  useEffect(() => {
    fetchInvoiceFilters();
  }, []);

  const fetchInvoiceData = async () => {
    const requestId = ++latestRequestRef.current;

    try {
      setLoading(true);

      const commonPayload = {
        yearMonth: toYearMonth(month),
        invoiceLineItemStatusIds: status?.join(",") || "",
        teamId: Number(teams) || null,
        clientId: Number(client) || null,
        searchText: searchQuery?.trim(),
        invoiceByUserId: isToDo ? loggedInUserid : null,
      };

      const summaryPayload = {
        ...commonPayload,
        infoCardInvltmStatus: activeFilter,
      };

      const [countResult, summaryResult] = await Promise.all([
        getInvoiceSummaryCount(commonPayload),
        getCurrentTabConfig().summaryApi(summaryPayload),
      ]);

      if (requestId !== latestRequestRef.current) return;

      if (countResult) {
        setInvoiceStats({
          invoiceAll: countResult.total_LineItems ?? "",
          pendingLineItems: countResult.pendingForInvoice_Count ?? "",
          readyToBill: countResult.invoiceReady_Count ?? "",
          readyToReBill: countResult.reInvoiceReady_Count ?? "",
          exceptions: countResult.exception_OnHold_Count ?? "",
          generatedInvoices: countResult.invoiced_Count ?? "",
        });
      }

      switch (activeTab) {
        case "Client":
          setClientInvoiceSummaries(summaryResult || []);
          break;
        case "Role":
          setRoleInvoiceSummaries(summaryResult || []);
          break;
        case "User":
          setUserInvoiceSummaries(summaryResult || []);
          break;
      }

      setTableKey(`table-${Date.now()}`);
    } catch (error) {
      console.error("Invoice fetch failed:", error);
    } finally {
      if (requestId === latestRequestRef.current) {
        setLoading(false);
      }
    }
  };

  const getCurrentInvoiceData = () => {
    switch (activeTab) {
      case "Client":
        return clientInvoiceSummaries;
      case "Role":
        return roleInvoiceSummaries;
      case "User":
        return userInvoiceSummaries;
      default:
        return clientInvoiceSummaries;
    }
  };

  const getListApi = () => {
    return getCurrentTabConfig().listApi;
  };

  const getDetailApi = () => {
    return getCurrentTabConfig().detailApi;
  };

  useEffect(() => {
    fetchInvoiceData();
  }, [activeTab, month, client, status, searchQuery, activeFilter]);

  const debounce = (func: Function, delay: number) => {
    let timer: NodeJS.Timeout;
    return (...args: any[]) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };

  const handleAccordionSelect = (key: string | null) => {
    if (accordianKey === key) {
      return;
    }
    setAccordianKey(key || "0");
  };

  const configurationAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item) => ({ ...item }))}
      activeKey={accordianKey}
      onSelect={handleAccordionSelect}
    />
  );

  const handleRowSelect = (rows: any[]) => {
    setSelectedRows(rows);
  };

  const handleAction = (action: string, row: any) => {
    setSelectedViewData(row);
    setShowInvoiceTab(true);
  };

  const handleCardClick = (filter: string) => {
    setActiveFilter(filter);
    setSelectedRows([]);
    setSelectedAction("");
  };

  const handleTabChange = (key: string | null) => {
    if (key) {
      setActiveTab(key);
      resetTable();
    }
  };

  const handleInputChange = debounce((value: string) => {
    if (value?.length >= 3 || value?.length === 0) {
      setClientInvoiceSummaries([]);
      setRoleInvoiceSummaries([]);
      setUserInvoiceSummaries([]);
      setSearchQuery(value);
      setTableKey(`table-${Date.now()}`);
      setSelectedRows([]);
      setSelectedAction("");
    }
  }, 300);

  const handlecloseActionDrawer = async (action?: any) => {
    setShowActionDrawer(false);
    if (action === "Save") {
      setSelectedRows([]);
      setSelectedAction("");
      fetchInvoiceData();
    }
  };

  const closeInvoiceModal = async (action?: any) => {
    setShowGenerateInvoiceModal(false);
    if (action === "Save") {
      setSelectedRows([]);
      setSelectedAction("");
      fetchInvoiceData();
    }
  };

  const handleReProcessLineItem = async () => {
    try {
      const invoiceLineItemIds = selectedRows
        ?.map((item: any) => item?.invoiceLineItemId)
        ?.filter(Boolean)
        ?.join(",");

      if (!invoiceLineItemIds) return;

      const response = await fetchSyncReProcessing(invoiceLineItemIds);
      const isSuccess = response?.isSuccess;
      setError(isSuccess ? "success" : "error");
      setSnackbarMessage(
        isSuccess
          ? "Invoice line items reprocessing completed successfully."
          : response?.result?.responseMessage ||
              response?.message ||
              "Reprocessing failed",
      );
      setSnackbarOpen(true);
      if (isSuccess) {
        fetchInvoiceData();
      }
    } catch (error) {
      setError("error");
      setSnackbarMessage("Something went wrong while reprocessing line items.");
      setSnackbarOpen(true);
    }
  };

  const handleActionChange = (value: string | number) => {
    setSelectedAction(value);
    if (
      value === ACTION_VALUES.ADD_NOTES ||
      value === ACTION_VALUES.ON_HOLD ||
      value === ACTION_VALUES.MISMATCH_INFO
    ) {
      setShowActionDrawer(true);
      setDrawerTitle("Add Notes");
    } else if (value === ACTION_VALUES.GENERATE_INVOICE) {
      setShowGenerateInvoiceModal(true);
    } else if (value === ACTION_VALUES.REPROCESS) {
      handleReProcessLineItem();
    } else if (value === ACTION_VALUES.RESOLVE) {
      const status = selectedRows?.[0]?.invoiceLineItemStatus || "";
      setShowActionDrawer(true);
      setDrawerTitle(resolveTitleMap[status] || "Resolve Invoice");
    }
  };

  const resetTable = () => {
    setMonth(new Date());
    setStatus([]);
    setTeams(null);
    setClient(null);
    setResetTableTrigger((prev) => !prev);
    resetAllData();
  };

  const resetAllData = () => {
    setTableKey(`table-${Date.now()}`);
    setClientInvoiceSummaries([]);
    setRoleInvoiceSummaries([]);
    setUserInvoiceSummaries([]);
    setSelectedRows([]);
    setSelectedAction("");
    setActiveFilter(MANAGE_INVOICE_CODES.ALL);
    setActiveCard("All Invoices");
    setSearchQuery("");
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  const resetAllDataForFilters = () => {
    setTableKey(`table-${Date.now()}`);
    setClientInvoiceSummaries([]);
    setRoleInvoiceSummaries([]);
    setUserInvoiceSummaries([]);
    setSelectedRows([]);
    setSelectedAction("");
    setSearchQuery("");
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  const handleResetFilters = () => {
    if (searchQuery) {
      resetAllDataForFilters();
    }
  };

  const handleClose = () => {
    setShowInvoiceTab(false);
    setSelectedRows([]);
    setSelectedAction("");
    fetchInvoiceData();
  };

  const {
    hasInvoiceStatus,
    hasInvoiceCancelStatus,
    hasStandardChargeBill,
    isDisabled,
  } = useMemo(() => {
    const rows = selectedRows ?? [];
    const rowCount = rows?.length;
    const isMultiRow = rowCount > 1;

    let hasInvoiceStatus = false;
    let hasInvoiceCancelStatus = false;
    let hasStandardChargeBill = false;
    let hasReadyToBillStatus = false;
    let hasExceptionsStatus = false;

    for (const row of rows) {
      const status = row.invoiceLineItemStatus;
      const isStandardCharge =
        row.taskName === "Standard Charge" && !row.subjectQmeScheduleID;

      if (!hasInvoiceStatus && INVOICE_STATUS_CONFIG.includes(status)) {
        hasInvoiceStatus = true;
      }

      if (
        !hasInvoiceCancelStatus &&
        (status === INVOICE_STATUS.CANCELLED ||
          status === INVOICE_STATUS.INVOICE_CANCELLED)
      ) {
        hasInvoiceCancelStatus = true;
      }

      if (
        isMultiRow &&
        isStandardCharge &&
        !hasStandardChargeBill &&
        [
          INVOICE_STATUS.EXCEPTION_NO_BILLING_CONFIG,
          INVOICE_STATUS.EXCEPTION_INVALID_BILLING_CONFIG,
        ].includes(status)
      ) {
        hasStandardChargeBill = true;
      }

      if (
        isMultiRow &&
        isStandardCharge &&
        !hasReadyToBillStatus &&
        READY_TO_INVOICE_STATUSES.includes(status)
      ) {
        hasReadyToBillStatus = true;
      }

      if (
        isMultiRow &&
        !hasExceptionsStatus &&
        REPROCESS_LINE_ITEM_EXCEP_STATUSES.includes(status)
      ) {
        hasExceptionsStatus = true;
      }

      if (
        hasInvoiceStatus &&
        hasInvoiceCancelStatus &&
        hasStandardChargeBill &&
        hasReadyToBillStatus &&
        hasExceptionsStatus
      ) {
        break;
      }
    }

    const isDisabled =
      rowCount === 0 ||
      (isMultiRow && hasInvoiceStatus) ||
      (isMultiRow && hasReadyToBillStatus && hasExceptionsStatus) ||
      hasInvoiceCancelStatus ||
      hasStandardChargeBill;

    return {
      hasInvoiceStatus,
      hasInvoiceCancelStatus,
      hasStandardChargeBill,
      isDisabled,
    };
  }, [selectedRows, isToDo]);

  const allowedValues = [ACTION_VALUES.ADD_NOTES, ACTION_VALUES.REPROCESS];
  const todosOptions = actionOptions.filter((item) =>
    allowedValues.includes(item.value),
  );

  return (
    <>
      <Snackbar
        open={snackbarOpen}
        message={snackbarMessage}
        onClose={() => setSnackbarOpen(false)}
        severity={error}
      />
      <div
        className={`breadcrumbg breadcrumbgNew pb-0 pt-1 ${
          isToDo ? "adjustBread" : ""
        }`}
      >
        <Container fluid className="px-5">
          <Stack direction="horizontal" gap={2}>
            <Row className="pt-0 fade-in-left">
              <Col>
                <h4>{isToDo ? "View Invoice" : "Invoice Management"}</h4>
              </Col>
            </Row>
          </Stack>
        </Container>
      </div>

      {!showInvoiceTab && (
        <div className="mt-3">
          <Container
            fluid
            className={`${isToDo ? "px-4" : "px-5"} invoiceManagment_sec`}
          >
            <Row className="g-3 invocasta">
              <Col md={2}>
                <Card
                  className={`h-100 todocard3 ${activeCard === "All Invoices" ? "active" : ""}`}
                  style={{
                    backgroundColor: "#F4F8FE",
                    borderRadius: "5px",
                    border: "1px solid #0092D5",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setActiveCard("All Invoices");
                    handleCardClick(MANAGE_INVOICE_CODES.ALL);
                    setActiveSubCard("");
                  }}
                >
                  <Card.Body className="d-flex flex-column justify-content-between p-1">
                    <div className="d-flex justify-content-between align-items-center">
                      <Card.Title
                        style={{
                          color: "#0092D5",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        All Line Items
                      </Card.Title>
                      <span
                        className="material-symbols-outlined"
                        style={{ color: "#0092D5" }}
                      >
                        receipt_long{" "}
                      </span>
                    </div>
                    <div
                      style={{
                        fontSize: "15px",
                        color: "#0092D5",
                        fontWeight: "600",
                      }}
                    >
                      {animatedInvoiceAll}
                    </div>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={2}>
                <Card
                  className={`h-100 todocard2 ${activeCard === "Line Items" ? "active" : ""}`}
                  style={{
                    backgroundColor: "#FCECBE",
                    borderRadius: "5px",
                    border: "1px solid #E6C872",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setStatus([]);
                    handleCardClick(MANAGE_INVOICE_CODES.PENDING_ALL);
                    setActiveCard("Line Items");
                    setActiveSubCard("Pending All");
                  }}
                >
                  <Card.Body className="d-flex flex-column justify-content-between p-1">
                    <div className="d-flex justify-content-between align-items-center">
                      <Card.Title
                        style={{
                          color: "#9C6F16",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Line Items
                      </Card.Title>
                      <span
                        className="material-symbols-outlined"
                        style={{ color: "#9b6d15" }}
                      >
                        notes
                      </span>
                    </div>

                    <div className="d-flex justify-content-start">
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          setStatus([]);
                          handleCardClick(MANAGE_INVOICE_CODES.PENDING_ALL);
                          setActiveCard("Line Items");
                          setActiveSubCard("Pending All");
                        }}
                        style={{
                          borderRight: "1px solid transparent",
                          padding: "0px 10px 0px 0px",
                          minWidth: "25px",
                          background:
                            "linear-gradient(to bottom, transparent 10%, #9b6d15 10%, #9b6d15 90%, transparent 90%) right / 1px 100% no-repeat",
                          cursor: "pointer",
                        }}
                        className={`px-1 ${activeSubCard === "Pending All" ? "active" : ""}`}
                      >
                        <div style={{ color: "#9b6d15" }}>All</div>
                        <div
                          style={{
                            fontSize: "15px",
                            color: "#9b6d15",
                            fontWeight: "600",
                          }}
                        >
                          {animatedPendingLineItems}
                        </div>
                      </div>
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          setStatus([]);
                          handleCardClick(MANAGE_INVOICE_CODES.READY_TO_BILL);
                          setActiveCard("Line Items");
                          setActiveSubCard("Ready To Bill");
                        }}
                        style={{
                          borderRight: "1px solid transparent",
                          padding: "0px 10px 0px 0px",
                          background:
                            "linear-gradient(to bottom, transparent 10%, #9b6d15 10%, #9b6d15 90%, transparent 90%) right / 1px 100% no-repeat",
                          cursor: "pointer",
                        }}
                        className={`px-1 ${activeSubCard === "Ready To Bill" ? "active" : ""}`}
                      >
                        <div style={{ color: "#9b6d15" }}>Ready To Bill</div>
                        <div
                          style={{
                            fontSize: "15px",
                            color: "#9b6d15",
                            fontWeight: "600",
                          }}
                        >
                          {animatedReadyToBill}
                        </div>
                      </div>

                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          setStatus([]);
                          handleCardClick(
                            MANAGE_INVOICE_CODES.READY_TO_RE_BILL,
                          );
                          setActiveCard("Line Items");
                          setActiveSubCard("Ready To Re-Bill");
                        }}
                        style={{
                          padding: "0px 10px 0px 10px",
                          cursor: "pointer",
                        }}
                        className={`px-1 ${activeSubCard === "Ready To Re-Bill" ? "active" : ""}`}
                      >
                        <div style={{ color: "#9b6d15" }}>Ready To Re-Bill</div>
                        <div
                          style={{
                            fontSize: "15px",
                            color: "#9b6d15",
                            fontWeight: "600",
                          }}
                        >
                          {animatedReadyToReBill}
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={2}>
                <Card
                  className={`h-100 todocard9  ${activeCard === "Exceptions" ? "active" : ""}`}
                  style={{
                    backgroundColor: "#f8dcb4",
                    borderRadius: "5px",
                    border: "1px solid #efca93",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setStatus([]);
                    setActiveCard("Exceptions");
                    handleCardClick(MANAGE_INVOICE_CODES.EXCEPTION);
                    setActiveSubCard("");
                  }}
                >
                  <Card.Body className="d-flex flex-column justify-content-between p-1">
                    <div className="d-flex justify-content-between align-items-center">
                      <Card.Title
                        style={{
                          color: "#995911",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Exceptions
                      </Card.Title>
                      <span
                        className="material-symbols-outlined"
                        style={{ color: "#995911" }}
                      >
                        question_mark
                      </span>
                    </div>

                    <div
                      style={{
                        fontSize: "15px",
                        color: "#995911",
                        fontWeight: "600",
                      }}
                    >
                      {animatedExceptions}
                    </div>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={2}>
                <Card
                  className={`h-100 todocard4 ${activeCard === "Generated Invoices" ? "active" : ""}`}
                  style={{
                    backgroundColor: "#E9E5FE",
                    borderRadius: "5px",
                    border: "1px solid #9C8CEE",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setStatus([]);
                    setActiveCard("Generated Invoices");
                    handleCardClick(MANAGE_INVOICE_CODES.GENERATED);
                    setActiveSubCard("");
                  }}
                >
                  <Card.Body className="d-flex flex-column justify-content-between p-1">
                    <div className="d-flex justify-content-between align-items-center">
                      <Card.Title
                        style={{
                          color: "#684fe5",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Invoiced Line Items
                      </Card.Title>
                      <span
                        className="material-symbols-outlined"
                        style={{ color: "#684fe5" }}
                      >
                        hourglass
                      </span>
                    </div>

                    <div
                      style={{
                        fontSize: "15px",
                        color: "#684fe5",
                        fontWeight: "600",
                      }}
                    >
                      {animatedGeneratedInvoices}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <div
              className="my-3"
              style={{ background: "#0092D5", height: "2px" }}
            ></div>
            <div
              className={`main_wrapper_section pills_wrapper ${
                isToDo
                  ? "fixed_headerOnscroll_viewInvoice"
                  : "fixed_headerOnscroll"
              }`}
            >
              <div className="mt-3 mb-3 invoiceManageWrapper">
                <div className="row">
                  {!isToDo ? (
                    <div className="col-md-3 col-xxl-4">
                      <Tabs
                        activeKey={activeTab}
                        onSelect={handleTabChange}
                        className="fade-in-left"
                      >
                        {tabConfigs.map((tab) => (
                          <Tab
                            key={tab.key}
                            eventKey={tab.key}
                            title={tab.title}
                          />
                        ))}
                      </Tabs>
                    </div>
                  ) : (
                    ""
                  )}
                  <div
                    className={`${isToDo ? "col-md-12 col-xxl-12" : "col-md-9 col-xxl-8"}`}
                  >
                    <Row className="justify-content-end g-1 adjustHeight50">
                      <Col sm={4} md={2} className="mt-2">
                        <FloatingLabelMonthPicker
                          label="Billing Month"
                          value={month}
                          onChange={(value) => {
                            setMonth(value);
                            resetAllDataForFilters();
                          }}
                        />
                      </Col>
                      {activeCard === "All Invoices" && (
                        <Col
                          sm={4}
                          md={2}
                          className="selection_dropdown mt-4 invoice_data"
                        >
                          <DropdownWithTooltip
                            value={status}
                            options={statusOptions}
                          >
                            <SearchableMultiSelectDropdown
                              label="Status"
                              name="Status"
                              options={statusOptions}
                              values={status}
                              onChange={(e, name, value) => {
                                setStatus(value);
                                resetAllDataForFilters();
                              }}
                            />
                          </DropdownWithTooltip>
                        </Col>
                      )}
                      <Col
                        sm={4}
                        md={3}
                        className="selection_dropdown mt-4 invoice_data"
                      >
                        <DropdownWithTooltip
                          value={client}
                          options={teamsOptions}
                        >
                          <SearchableSingleSelectDropdown
                            label="Team / Client"
                            name="TeamClient"
                            options={teamsOptions}
                            value={client}
                            onChange={(e, name, value) => {
                              setClient(value);
                              const selectedTeam = teamsOptions.find(
                                (option) => option.value === value,
                              );

                              const teamId = selectedTeam?.teamId || null;
                              setTeams(teamId);
                              resetAllDataForFilters();
                            }}
                          />
                        </DropdownWithTooltip>
                      </Col>
                      <Col
                        sm={4}
                        md={3}
                        className={`mt-3 ${
                          isToDo
                            ? activeCard === "All Invoices"
                              ? "shortwidth"
                              : "fullWidth"
                            : ""
                        }`}
                      >
                        <InputGroup className="w-auto px-2">
                          <InputGroup.Text className="px-2">
                            <span className="material-symbols-outlined text-black-50">
                              search
                            </span>
                          </InputGroup.Text>
                          <Form.Control
                            ref={inputRef}
                            aria-label="Search"
                            onChange={(e) =>
                              handleInputChange(e.target.value.trim())
                            }
                            onPaste={(e) => {
                              e.preventDefault();
                              const text = e.clipboardData
                                .getData("text")
                                .trim();
                              handleInputChange(text);
                              if (inputRef.current)
                                inputRef.current.value = text;
                            }}
                          />
                        </InputGroup>
                      </Col>
                      <Col
                        sm={0}
                        md={2}
                        className={`mt-3 ${
                          isToDo
                            ? activeCard === "All Invoices"
                              ? "shortwidth_action"
                              : "fullWidth_action"
                            : ""
                        }`}
                      >
                        <div className="px-0">
                          <Button
                            className="d-flex align-items-center"
                            style={{
                              background: "none",
                              border: "none",
                              padding: "10px",
                              fontSize: "22px",
                            }}
                            onClick={handleResetFilters}
                          >
                            <span className="material-icons reset_ic0">
                              restart_alt
                            </span>
                          </Button>

                          <span>
                            <AppointmentActionsDropdown
                              name="Actions"
                              options={!isToDo ? actionOptions : todosOptions}
                              value={selectedAction}
                              onChange={handleActionChange}
                              disabled={isDisabled}
                              forInvoice={true}
                            />
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ marginBottom: "40px" }}>
              {configurationAccordion([
                {
                  title: "List",
                  content: (
                    <>
                      <NestedExpandableTable
                        key={tableKey}
                        headers={getHeaders()}
                        filterPayload={{
                          yearMonth: toYearMonth(month),
                          invoiceLineItemStatusIds: status?.join(",") || "",
                          teamId: Number(teams) || null,
                          searchText: searchQuery?.trim(),
                          infoCardInvltmStatus: activeFilter,
                          invoiceByUserId: isToDo ? loggedInUserid : null,
                        }}
                        activeTab={activeTab}
                        clientInvoiceData={getCurrentInvoiceData()}
                        getInvoiceByClientQme={getListApi()}
                        getChildUser={getDetailApi()}
                        onRowSelect={handleRowSelect}
                        onAction={handleAction}
                        selectedRowIds={selectedRows
                          ?.map((row) => row?.id)
                          .filter(Boolean)}
                        resetTrigger={resetTableTrigger}
                        isLoader={loading}
                        isToDo={isToDo}
                        loggedInUserid={loggedInUserid}
                      />
                    </>
                  ),
                },
              ])}
            </div>
          </Container>
        </div>
      )}
      <HistorianActionDrawer
        title={drawerTitle}
        open={showActionDrawer}
        onClose={handlecloseActionDrawer}
        placement="end"
      >
        {(selectedAction == "Add Notes" ||
          selectedAction == "On Hold" ||
          selectedAction == "Mismatch/Incorrect Info") && (
          <InvoiceAddNotes
            showDrawer={showActionDrawer}
            onClose={handlecloseActionDrawer}
            caseInfoId={selectedRows[0]?.caseInfoId}
            caseId={selectedRows[0]?.caseId}
            isRowActionTriggered={true}
            onNotesSaved={() => {}}
            subjectQmeScheduleID={selectedRows[0]?.subjectQmeScheduleID}
            lineItemInvoiceID={selectedRows[0]?.invoiceLineItemId}
            selectedAction={selectedAction}
          />
        )}

        {selectedAction == "Resolve" && (
          <InvoiceResolve
            showDrawer={showActionDrawer}
            onClose={handlecloseActionDrawer}
            selectedRows={selectedRows}
          />
        )}
      </HistorianActionDrawer>
      {showInvoiceTab && (
        <ViewInvoice selectedRow={selectedViewData} onClose={handleClose} />
      )}
      {showGenerateInvoiceModal && (
        <GenerateInvoice
          show={showGenerateInvoiceModal}
          onClose={closeInvoiceModal}
          selectedRow={selectedRows}
          month={month}
          activeTab={activeTab}
          clientInvoiceSummaries={getCurrentInvoiceData()}
          userInfo={userInfo}
        />
      )}
    </>
  );
};

export default Invoice;
